module.exports = __webpack_public_path__ + "media/bundles/ZisTop/libs/Rubik/RubikRegularLatin-03d4d0264f85346b9b803264adc9d915.woff2";